'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$1 = require('./styles-20009c57.js');

/* eslint-disable max-lines-per-function */
var Chip = function (_a) {
    var value = _a.value, label = _a.label, _b = _a.isActive, isActive = _b === void 0 ? false : _b, _c = _a.cancelEnabled, cancelEnabled = _c === void 0 ? false : _c, onCancel = _a.onCancel, dataCy = _a.dataCy, className = _a.className, onChipClick = _a.onChipClick;
    var onCancelClick = React.useCallback(function (event) {
        event.stopPropagation();
        // eslint-disable-next-line no-unused-expressions
        onCancel === null || onCancel === void 0 ? void 0 : onCancel(value);
    }, [onCancel, value]);
    var onContainerClick = React.useCallback(function () { return onChipClick === null || onChipClick === void 0 ? void 0 : onChipClick(value); }, [onChipClick, value]);
    var handleOnKeyDownContainer = React.useCallback(function (event) {
        event.stopPropagation();
        if (event.key === 'Enter' || event.key === ' ') {
            onContainerClick();
        }
    }, [onContainerClick]);
    var handleOnKeyDownCancel = React.useCallback(function (event) {
        event.stopPropagation();
        if (event.key === 'Enter' || event.key === ' ') {
            onCancelClick(event);
        }
    }, [onCancelClick]);
    return (React__default.createElement(styles$1.ChipContainer, { isActive: isActive, "data-cy": dataCy, "data-testid": "chip-container", className: className, onClick: onContainerClick, tabIndex: onChipClick ? 0 : undefined, onKeyDown: onChipClick ? handleOnKeyDownContainer : undefined, role: onChipClick ? 'button' : 'presentation', isClickable: !!onChipClick },
        React__default.createElement(styles$1.ChipText, { isActive: isActive, className: "chip-text" }, label),
        cancelEnabled
            && (React__default.createElement(styles$1.StyledCancel, { size: "sm", variant: isActive ? 'primary' : 'adminBlack', onClick: onCancelClick, "data-testid": "chip-cancel-button", className: "chip-cancel-button", tabIndex: 0, onKeyDown: handleOnKeyDownCancel, role: "button" }))));
};

exports.Chip = Chip;
